import _ from 'lodash/fp';
import T from 'prop-types';
import React from 'react';
import { PRODUCT_PROS_CONS } from '../../../constants/product';
import Tooltip from '../../Tooltip';
import { IconButton } from '../../button';
import ProductCard from '../productCard/ProductCard';
var ProductTooltip = function(param) {
    var productType = param.productType, title = param.title, description = param.description, placement = param.placement, keepOpenOnHover = param.keepOpenOnHover;
    var pros = _.get([
        productType,
        'pros'
    ], PRODUCT_PROS_CONS);
    var cons = _.get([
        productType,
        'cons'
    ], PRODUCT_PROS_CONS);
    return /*#__PURE__*/ React.createElement(Tooltip.Provider, {
        placement: placement,
        keepOpenOnHover: keepOpenOnHover
    }, /*#__PURE__*/ React.createElement(Tooltip.Trigger, null, /*#__PURE__*/ React.createElement(IconButton, {
        className: "product-tooltip",
        icon: "question"
    })), /*#__PURE__*/ React.createElement(Tooltip.Content, {
        withArrow: true,
        arrowProps: {
            fill: '#2a2a2a'
        }
    }, /*#__PURE__*/ React.createElement(ProductCard, {
        productType: productType,
        pros: pros,
        cons: cons,
        isDisabled: false,
        handleClick: _.noop,
        variant: "secondary",
        withExplanation: true,
        title: title,
        description: description
    })));
};
ProductTooltip.propTypes = {
    productType: T.string.isRequired,
    title: T.string,
    description: T.string,
    placement: T.string,
    keepOpenOnHover: T.bool
};
export default ProductTooltip;
